var map = {
	"./mirk-accounting.jpg": "17ca",
	"./mirka-accounting1.png": "f680",
	"./mirka-accounting2.png": "20a9",
	"./mirka-accounting3.png": "1cce",
	"./mirka-accounting4.png": "44c6",
	"./online-ordering.jpg": "0f6a",
	"./restaurant.jpg": "f410",
	"./travel-agency.jpg": "bf96",
	"./travel1.png": "3da1",
	"./travel2.png": "ac3f",
	"./travel3.png": "efb0",
	"./travel4.png": "b980"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3296";